
export default {
    props: {
        /**
         * The address object
         */
        address: {
            type: Object,
            required: true,
        },
        /**
         * Are we editing this address?
         */
        editing: {
            type: Boolean,
            default: false,
        },
        /**
         * Should we show the default indicator
         */
        showDefault: {
            type: Boolean,
            default: true,
        },
    },
};
